import { render, staticRenderFns } from "./CustomsInvoiceDetails.vue?vue&type=template&id=1c1a8446&"
import script from "./CustomsInvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./CustomsInvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomsInvoiceDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
